import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 20px;

    > span {
        font-size: 12px;
        font-weight: 300;
        color: #EE1B24;
        margin-left: auto;
    }

    form {
        width: 100%;

        div + div {
            margin-top: 20px;
        }
    }

    button {
        width: 100%;
    }
`;

export { Container };